import type { SVGProps } from 'react';

export const Block = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'availability-block-icon'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-1024, -498)">
        <g transform="translate(1000, 378)">
          <g transform="translate(24, 120)">
            <rect height="18" width="18" x="0" y="0"></rect>
            <g transform="translate(0.1581, 0.0522)">
              <path
                d="M8.84185819,0.900000164 C12.0533712,0.8992723 14.9490628,2.83328079 16.1785602,5.80012301 C17.4080575,8.76696523 16.7292063,12.18231 14.458581,14.4534501 C12.1879558,16.7245902 8.77276508,17.4042158 5.80564417,16.1753911 C2.83852326,14.9465665 0.90385819,12.0513135 0.90385819,8.83980037 C0.907826104,4.45711716 4.45917599,0.904961976 8.84185819,0.900000164 M8.84185819,1.84478012e-07 C5.26632913,-0.000727696342 2.04246488,2.15255876 0.673664634,5.45570794 C-0.695135614,8.75885712 0.0607157864,12.5613079 2.58873924,15.0898462 C5.11676269,17.6183845 8.91905946,18.3750103 12.2224873,17.0068827 C15.5259152,15.6387552 17.6798584,12.4153295 17.6798584,8.83980037 C17.6803356,6.49550518 16.7494027,4.24706284 15.0919044,2.589227 C13.4344061,0.93139116 11.1861534,1.84478012e-07 8.84185819,1.84478012e-07 Z"
                fill="#3D57FF"
                fillRule="nonzero"
              ></path>
              <line
                stroke="#3D57FF"
                strokeWidth="0.9"
                x1="14.6666582"
                x2="2.60485819"
                y1="2.72160037"
                y2="14.7816004"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
